

























































import { Component, Vue, Prop, } from 'vue-property-decorator';
import { General } from '@/services/General';
import axios from 'axios';
import { DropDownItem } from "@/services/DropDownItem";
import Autocomplete from '@trevoreyre/autocomplete-vue';
import { i18n } from '@/i18n/i18n-setup';

interface UserMatrixDto {
    idUser: string
    userTypeDescription?: string
    userType: string
    idCountry: string
    idChannel: number
    username?: string
    country?: string
    channel?: string
}
interface MassiveUserMatrixDto {
    idUser: string,
    userType: Array<string>,
    idCountry: Array<string>,
    idChannel: Array<number>
}
interface selectedUser {
    username: string,
    idUser: string,
}

interface IDataDummyOutput {
        data: any[]
    }

@Component({
    components: {
        Autocomplete
    }
})

export default class UserMatrixForm extends Vue {

    @Prop({ type: Array, required: false })
    dropDownCountriesProp: Array<any>;
    @Prop({ type: Array, required: false })
    dropDownChannelsProp: Array<any>;
    @Prop({ type: Array, required: false })
    dropDownUserTypesProp: Array<any>;
    @Prop({ type: Object, required: false })
    selectedUserProp: selectedUser;
    @Prop({ type: Array, required: false })
    matrixDetailsProp: Array<UserMatrixDto>;

    //selected fields
    advUserTypeFilter: Array<string> = null;
    advUserCountryFilter: Array<string> = null;
    advIdChannelFilter: Array<number> = null;
    advUsernameFilter: string = null;
    advUserId: string = null;
    advChannelFilter: string = null;

    isOnSubmit: boolean = false;

    dropDownUsers: Array<any> = null;
    dropDownChannels: Array<any> = null;
    dropDownUserTypes: Array<any> = null;
    dropDownUserTypesTemp: Array<any> = null;
    dropDownCountries: Array<any> = null;
    matrixDetails: Array<UserMatrixDto> = null;

    //autocomplete
    object: any = null;
    defaultValue: string = null;
    result: any = null;
    placeHolder: string = null;
    autoSelect: boolean = null;
    value: string = null;
    loading:boolean = true;


    async mounted() {
        if (this.selectedUserProp != null) {
            this.advUsernameFilter = this.selectedUserProp.username;
            this.advUserId = this.selectedUserProp.idUser;
        }
        if(this.matrixDetailsProp != null) {
            this.matrixDetails = this.matrixDetailsProp;
        }
        this.dropDownCountries = this.dropDownCountriesProp ?? await this.getDropdownCountries();
        this.dropDownChannels = this.dropDownChannelsProp ?? await this.getDropDownChannels();
        this.dropDownUserTypes = this.dropDownUserTypesProp ?? await this.getDropDownUserType();          
        this.dropDownUsers = await this.getDropDownAllUsers();

        this.dropDownUserTypesTemp = this.dropDownUserTypes;
        this.loading = false;
    }

    onInputFilterUserType() {   
        if(this.advUserTypeFilter.length > 0 && !this.advUserTypeFilter.includes('R'))
            this.dropDownUserTypes = this.dropDownUserTypes.filter(x => x.value !== 'R')
        else if(this.advUserTypeFilter.length > 0 && this.advUserTypeFilter.includes('R'))
            this.dropDownUserTypes = this.dropDownUserTypes.filter(x => x.value === 'R')
        else
            this.dropDownUserTypes = this.dropDownUserTypesTemp;
    }

    async getDropdownCountries(): Promise<Array<any>> {
        try {
            let country: DropDownItem = new DropDownItem();
            let countryList: DropDownItem[] = [];

            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/Culture/GetCountriesAll'), {
                responseType: "json",
                withCredentials: true
            });

            if (response.data) {
                response.data.forEach(element => {
                    country = new DropDownItem();
                    country.idDropDownItem = element.idCountry;
                    country.itemText = element.name;

                    countryList.push(country);
                });
                return General.SetOptionsDropDown(countryList, false);
            }
        } catch (ex) {
            General.HandleError(ex, this);
            return null;
        }
    }

    async getDropDownChannels(): Promise<Array<any>> {
        try {
            let channel: DropDownItem = new DropDownItem();
            let channelList: DropDownItem[] = [];

            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/net20/GetAllChannelsDetail'), {
                responseType: "json",
                withCredentials: true
            });

            if (response.data) {
                response.data.forEach(element => {
                    channel = new DropDownItem();
                    channel.idDropDownItem = element.id;
                    channel.itemText = element.description;

                    channelList.push(channel);
                });

                return General.SetOptionsDropDown(channelList, false);
            }

        } catch (ex) {
            General.HandleError(ex, this);
            return null;
        }
    }

    async getDropDownUserType(): Promise<Array<any>> {
        let userType: DropDownItem = new DropDownItem();
        let userTypeList: DropDownItem[] = [];

        let usersTypes = [
            {
                name: i18n.t('NET20.USER_MANAGEMENT_SALESMAN') as string,
                value: 'S'
            },
            {
                name: i18n.t('NET20.USER_MANAGEMENT_MARKETING_MANAGER') as string,
                value: 'M'
            },
            {
                name: i18n.t('NET20.USER_MANAGEMENT_ONLY_READ') as string,
                value: 'R'
            }
        ]

        usersTypes.forEach(e => {
            userType = new DropDownItem();
            userType.idDropDownItem = e.value;
            userType.itemText = e.name;

            userTypeList.push(userType);
        })

        return General.SetOptionsDropDown(userTypeList, false);
    }

    async getDropDownAllUsers(): Promise<Array<any>> {
        let user: DropDownItem = new DropDownItem();
        let userList: DropDownItem[] = [];
        try {
            let response: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/userprofile/GetUsersWithFilter'),
                data: {},
                withCredentials: true,
                responseType: 'json'
            });

            if (response.data.listPage.length > 0) {
                response.data.listPage.forEach(element => {
                    user = new DropDownItem();

                    user.itemText = element.username;
                    user.idDropDownItem = element.idUser

                    userList.push(user);
                });

                return General.SetOptionsDropDown(userList);
            }
        } catch (error) {
            General.HandleError(error, this);

        }
    }

    async createMatrix() {
        this.isOnSubmit = true;
        let validationResult = this.checkAllValues();
        if(validationResult) {
            let validateOnlyReadRole = await this.validateOnlyReadRole();
            if (validateOnlyReadRole) {
                let message = i18n.t('NET20.USER_MANAGEMENT_CREATE_QUESTION') as string;

                General.confirm(
                    message,
                    this,
                    async () => {
                        await this.createMatrixDo();
                        this.isOnSubmit = false;
                    }
                );
            }
        }
    }

    async createMatrixDo() {
        this.loading = true;
        let matrixToCreate: MassiveUserMatrixDto = {
            idUser: this.advUserId,
            userType: this.advUserTypeFilter,
            idCountry: this.advUserCountryFilter,
            idChannel: this.advIdChannelFilter,
        }
        try {
            await axios.post<any>(
                General.GetApiUrl('/api/net20/CreateMassiveUserMatrixAsync'),
                matrixToCreate,
                {
                    withCredentials: true,
                    responseType: 'json',
                },
            );
            this.closeModal("matrix-details-modal");
            this.closeModal("matrix-form-user-modal");
            this.closeModal("matrix-form-modal");

            this.loading = false;
            General.showAlertSuccess(i18n.t('NET20.USER_MANAGEMENT_CREATE_SUCCESS') as string, this);
            this.refereshMatrixResults();
        } catch (e) {
            if(e.response.status == 409) {
                General.showAlertDanger(i18n.t('NET20.MSG_USER_AUTHORIZATION_ALREADY_INSERTED') as string, this);
            } else {
                General.HandleError(e, this);
            }
        }
    }

    async validateOnlyReadRole() : Promise<boolean> {
        let check: boolean = true;
        let matrix: UserMatrixDto = null;
        let errorMessage: string = null;

        if(this.matrixDetails == null)
            await this.getUserMatrix();

        if(this.advUserTypeFilter.includes('R')) {
            matrix = this.matrixDetails.filter(x => x.userType !== 'R'
                                                            && this.advUserCountryFilter.includes(x.idCountry)
                                                            && this.advIdChannelFilter.includes(x.idChannel))[0]
            if(matrix != null) {
                check = false;
                errorMessage = i18n.t('NET20.MSG_USER_AUTHORIZATION_DELETE_OTHER_ROLES') as string;
                errorMessage = errorMessage.replace('{0}', this.advUsernameFilter).replace('{1}', matrix.channel).replace('{2}', matrix.country);
                General.showAlertDanger(errorMessage, this);
            }
        } else {
            matrix = this.matrixDetails.filter(x => x.userType === 'R'
                                                            && this.advUserCountryFilter.includes(x.idCountry)
                                                            && this.advIdChannelFilter.includes(x.idChannel))[0]
            if(matrix != null) {
                check = false;
                errorMessage = i18n.t('NET20.MSG_USER_AUTHORIZATION_DELETE_READ_ONLY') as string;
                errorMessage = errorMessage.replace('{0}', this.advUsernameFilter).replace('{1}', matrix.channel).replace('{2}', matrix.country);
                General.showAlertDanger(errorMessage, this);
            }
        }
        return check;
    }

    async getUserMatrix() {
        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/net20/GetUserMatrixForUser'),
                data: {
                    UserId: this.advUserId,
                },
                withCredentials: true,
                responseType: 'json'
            });
            if(results != null) {
                this.matrixDetails = results.data.listPage;
            } else {
                this.matrixDetails = new Array<UserMatrixDto>();
            }
        } catch (error) {
            General.HandleError(error, this);
        }
    }

    closeModal(modalName: string) {
        this.$bvModal.hide(modalName);
    }

    refereshMatrixResults() {
        this.$emit('refreshMatrixResults')
    }

    checkAllValues(): boolean {
        if(this.validationSelect(this.advUserCountryFilter == null || this.advUserCountryFilter.length == 0, true)) {
            General.showAlertDanger(i18n.t('NET20.USER_MANAGEMENT_VALIDATION_COUNTRY') as string, this);
            return false;
        } else if(this.validationSelect(this.advUserTypeFilter == null || this.advUserTypeFilter.length == 0, true)) {
            General.showAlertDanger(i18n.t('NET20.USER_MANAGEMENT_VALIDATION_USERTYPE') as string, this);
            return false;
        } else if(this.validationSelect(this.advIdChannelFilter == null || this.advIdChannelFilter.length == 0, true)) {
            General.showAlertDanger(i18n.t('NET20.USER_MANAGEMENT_VALIDATION_CHANNELTYPE') as string, this);
            return false;
        } else if(this.validationSelect(this.advUsernameFilter == null, true)) {
            return false;
        }

        return true;
    }

    validationSelect(validationResult: boolean, isOnSubmit: boolean): boolean {
        if (isOnSubmit) {
            return validationResult
        }
        return null;
    }

    async search(input) {
        let usernameToLowerArray = [];
        this.resetItem();
        if (input != null && input != '') {
            this.dropDownUsers.filter(user => {
                if (user.text.toLowerCase().includes(input.toLowerCase())) {
                    usernameToLowerArray.push(user)
                }

            })
            return usernameToLowerArray;
        } else{
            let dataOutput = {
                    data: []
                };
                let promiseDummy = await new Promise<IDataDummyOutput>((resolve) => {
                    resolve(dataOutput);
                });
                return promiseDummy.data;
        }
    }

    submit(result) {
        this.advUsernameFilter = result.text
        this.advUserId = result.value
        this.$emit('selected', result, this.object);
    }

    resetItem() {
        this.advUsernameFilter = null;
        this.$emit('selected', null, this.object);
    }

    getResultValue(result) {
        return result.text
    }
}
